import { render } from "./AssetAccessories.vue?vue&type=template&id=176a9dfc"
import script from "./AssetAccessories.vue?vue&type=script&lang=js"
export * from "./AssetAccessories.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__